import {acceptHMRUpdate, defineStore} from "pinia";
import type {ViewMeQuery} from "../graphql";

interface State {
	profile?: NonNullable<ViewMeQuery["me"]>;
	// Whether the client-side profile fetch has finished (successfully or not, or was
	// skipped because the visitor isn't logged in). Never true during SSR or hydration,
	// see the `customer-login` plugin.
	isLoaded: boolean;
}

export const useProfile = defineStore("profile", {
	state: (): State => ({
		profile: undefined,
		isLoaded: false,
	}),

	actions: {
		setProfile(profile: NonNullable<ViewMeQuery["me"]>) {
			this.profile = profile;
		},
		setLoaded() {
			this.isLoaded = true;
		},
		flushProfile() {
			this.profile = undefined;
		},
	},
});

if (import.meta.hot) {
	import.meta.hot.accept(acceptHMRUpdate(useProfile, import.meta.hot));
}
